module.exports = __webpack_public_path__ + "static/img/1.a214f47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/1.png
// module id = gJ+P
// module chunks = 0